module.exports = __webpack_public_path__ + "img/flower-top.b1e14354.png";